export default "__VITE_ASSET__DTDBA3cJ__"